import { useEffect } from 'react';

import { useAaId } from '@trello/authentication';
import { sendErrorEvent } from '@trello/error-reporting';

import { fetchUserPersonalization } from './fetchUserPersonalization';
import { isValidTraitName } from './traits';
import { useIsOptimizedUserTraitsEnabled } from './useIsOptimizedUserTraitsEnabled';
import { userTraitsSharedState } from './userTraitsSharedState';

export const useInitializeUserTraits: () => void = () => {
  const aaId = useAaId();
  const isOptimizedUserTraitsEnabled = useIsOptimizedUserTraitsEnabled();

  useEffect(() => {
    if (!isOptimizedUserTraitsEnabled) {
      return;
    }

    if (aaId && !userTraitsSharedState.value[aaId]) {
      userTraitsSharedState.setValue({
        ...userTraitsSharedState.value,
        [aaId]: {
          attributes: [],
          loading: true,
        },
      });
      fetchUserPersonalization(aaId)
        .then(({ attributes }) => {
          const validAttributes = attributes.filter((attr) =>
            isValidTraitName(attr.name),
          );
          userTraitsSharedState.setValue({
            ...userTraitsSharedState.value,
            [aaId]: {
              attributes: validAttributes,
              loading: false,
            },
          });
        })
        .catch((error) => {
          sendErrorEvent(error);
          userTraitsSharedState.setValue({
            ...userTraitsSharedState.value,
            [aaId]: {
              attributes: [],
              loading: false,
            },
          });
        });
    }
  }, [aaId, isOptimizedUserTraitsEnabled]);
};
